import * as React from 'react'

const Search = (props: { className?: string }) => (
  <svg {...props} viewBox='0 0 19 19' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      clipRule='evenodd'
      d='M12.6834 6.34172C12.6834 9.8434 9.84411 12.6834 6.34172 12.6834C2.83933 12.6834 0 9.8434 0 6.34172C0 2.83933 2.83933 0 6.34172 0C9.84411 0 12.6834 2.83933 12.6834 6.34172V6.34172Z'
      transform='translate(1 1)'
      stroke='#666'
      strokeWidth='2'
      strokeLinecap='square'
    />
    <path
      clipRule='evenodd'
      d='M0.498177 0L0 0.498177L4.93245 5.43063L5.43063 4.93245L0.498177 0V0Z'
      transform='translate(11.57 11.57)'
      stroke='#666'
      strokeWidth='2'
      strokeLinecap='square'
    />
  </svg>
)

export default Search



// WEBPACK FOOTER //
// ./src/components/icons/ui/Search.tsx